// Tia's Kitchen — scripts propios (tk-). Vanilla JS, sin librerías externas.

function tkInitReveal() {
  const els = document.querySelectorAll('.tk-reveal:not(.tk-reveal-bound)');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('tk-visible', 'tk-reveal-bound'));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('tk-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );
  els.forEach((el, i) => {
    el.classList.add('tk-reveal-bound');
    if (!el.style.getPropertyValue('--tk-delay')) {
      el.style.setProperty('--tk-delay', String((i % 6) * 90));
    }
    observer.observe(el);
  });
}

function tkInitFaq() {
  const items = document.querySelectorAll('.tk-faq__item:not(.tk-faq-bound)');
  items.forEach((item) => {
    item.classList.add('tk-faq-bound');
    const btn = item.querySelector('.tk-faq__pregunta');
    const panel = item.querySelector('.tk-faq__respuesta');
    if (!btn || !panel) return;
    btn.addEventListener('click', () => {
      const abierto = item.classList.contains('tk-abierto');
      item.parentElement.querySelectorAll('.tk-faq__item.tk-abierto').forEach((otro) => {
        if (otro !== item) {
          otro.classList.remove('tk-abierto');
          otro.querySelector('.tk-faq__respuesta').style.maxHeight = null;
          otro.querySelector('.tk-faq__pregunta').setAttribute('aria-expanded', 'false');
        }
      });
      if (abierto) {
        item.classList.remove('tk-abierto');
        panel.style.maxHeight = null;
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('tk-abierto');
        panel.style.maxHeight = panel.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function tkInitGaleria() {
  const galerias = document.querySelectorAll('.tk-galeria:not(.tk-galeria-bound)');
  galerias.forEach((galeria) => {
    galeria.classList.add('tk-galeria-bound');
    const principal = galeria.querySelector('.tk-galeria__principal img');
    const minis = galeria.querySelectorAll('.tk-galeria__mini');
    minis.forEach((mini) => {
      mini.addEventListener('click', () => {
        const src = mini.getAttribute('data-full');
        const alt = mini.getAttribute('data-alt') || '';
        if (principal && src) {
          principal.setAttribute('src', src);
          principal.setAttribute('alt', alt);
        }
        minis.forEach((m) => m.classList.remove('tk-activa'));
        mini.classList.add('tk-activa');
      });
    });
  });
}

function tkInitVariantes() {
  const formularios = document.querySelectorAll('.tk-form-producto:not(.tk-variantes-bound)');
  formularios.forEach((form) => {
    form.classList.add('tk-variantes-bound');
    const datosEl = form.querySelector('[data-variantes-json]');
    const inputId = form.querySelector('input[name="id"]');
    const selectores = form.querySelectorAll('[data-opcion-nombre]');
    const precioEl = form.closest('.tk-producto')?.querySelector('[data-precio-actual]');
    const precioAnteriorEl = form.closest('.tk-producto')?.querySelector('[data-precio-anterior]');
    const descuentoEl = form.closest('.tk-producto')?.querySelector('[data-precio-descuento]');
    const botonEl = form.querySelector('[data-boton-comprar]');
    if (!datosEl || !selectores.length) return;
    let variantes = [];
    try {
      variantes = JSON.parse(datosEl.textContent);
    } catch (e) {
      return;
    }
    function actualizar() {
      const seleccionados = Array.from(selectores).map((sel) => sel.value);
      const variante = variantes.find((v) => v.options.every((valorOpcion, i) => valorOpcion === seleccionados[i]));
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = variante.price;
      if (precioAnteriorEl) {
        if (variante.compareAtPrice) {
          precioAnteriorEl.textContent = variante.compareAtPrice;
          precioAnteriorEl.style.display = '';
        } else {
          precioAnteriorEl.style.display = 'none';
        }
      }
      if (descuentoEl) {
        if (variante.compareAtPriceRaw && variante.priceRaw) {
          const pct = Math.round(((variante.compareAtPriceRaw - variante.priceRaw) / variante.compareAtPriceRaw) * 100);
          descuentoEl.textContent = '-' + pct + '%';
          descuentoEl.style.display = '';
        } else {
          descuentoEl.style.display = 'none';
        }
      }
      if (botonEl) {
        if (variante.available) {
          botonEl.removeAttribute('disabled');
          botonEl.textContent = botonEl.getAttribute('data-texto-disponible') || botonEl.textContent;
        } else {
          botonEl.setAttribute('disabled', 'disabled');
          botonEl.textContent = botonEl.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
    }
    selectores.forEach((sel) => sel.addEventListener('change', actualizar));
  });
}

function tkInitAll() {
  tkInitReveal();
  tkInitFaq();
  tkInitGaleria();
  tkInitVariantes();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tkInitAll);
} else {
  tkInitAll();
}
document.addEventListener('shopify:section:load', tkInitAll);
